import { createPinia } from 'pinia'
import { useAppStore } from '@/pinia/modules/app'
import { useUserStore } from '@/pinia/modules/user'
import { useDictionaryStore } from '@/pinia/modules/dictionary'
import { useGameStore } from '@/pinia/modules/game'
import { useVipStore } from '@/pinia/modules/vip'
import { usePropsStore } from '@/pinia/modules/props'
import { useAvatarStore } from '@/pinia/modules/avatar'
import { useTagsStore } from '@/pinia/modules/tags'
import { useChannelStore } from '@/pinia/modules/channel'
const store = createPinia()

export { store, useAppStore, useUserStore, useDictionaryStore, useGameStore, useVipStore, usePropsStore, useAvatarStore, useTagsStore, useChannelStore }
